import { useTranslation } from 'react-i18next';

export default function Problem() {
  const { t } = useTranslation();
  
  const problems = [
    {
      icon: 'ri-time-line',
      title: t('problem.items.waiting.title'),
      description: t('problem.items.waiting.description'),
      color: 'from-red-500 to-orange-500'
    },
    {
      icon: 'ri-team-line',
      title: t('problem.items.disorganized.title'),
      description: t('problem.items.disorganized.description'),
      color: 'from-orange-500 to-yellow-500'
    },
    {
      icon: 'ri-calendar-close-line',
      title: t('problem.items.followups.title'),
      description: t('problem.items.followups.description'),
      color: 'from-yellow-500 to-red-500'
    },
    {
      icon: 'ri-message-3-line',
      title: t('problem.items.chaotic.title'),
      description: t('problem.items.chaotic.description'),
      color: 'from-red-500 to-pink-500'
    }
  ];

  return (
    <section 
      className="relative py-24 px-6 overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, #000000 0%, #0a0e14 30%, #1b2433 70%, #0a0e14 100%)'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-bl from-red-900/5 via-transparent to-orange-900/5"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-500/10 border border-red-500/30 rounded-full mb-6">
            <i className="ri-alert-line text-red-400"></i>
            <span className="text-red-300 text-sm font-medium">{t('problem.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('problem.title')}<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-orange-400">{t('problem.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {t('problem.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="group relative bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-red-500/50 transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
              
              <div className="relative z-10">
                <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${problem.color} mb-6`}>
                  <i className={`${problem.icon} text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-white mb-4">{problem.title}</h3>
                <p className="text-gray-400 leading-relaxed">{problem.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-gray-900/80 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 max-w-3xl">
            <p className="text-2xl font-bold text-white mb-4">
              <i className="ri-error-warning-line text-red-400 mr-2"></i>
              {t('problem.warning')}
            </p>
            <p className="text-gray-400">
              {t('problem.warningSubtitle')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
